import { trapFocus, removeTrapFocus } from '@theme/focus';
import { DialogCloseEvent, DialogOpenEvent } from '@theme/dialog';

const POPUP_LINK_SELECTOR = '.popup-link';
const INITIALIZED_ATTRIBUTE = 'data-custom-focus-trap';

/**
 * Custom: Keep popup-link modal/drawer keyboard focus inside the open dialog.
 *
 * @param {Element} popupLink
 */
function initPopupLinkFocusTrap(popupLink) {
  if (!(popupLink instanceof HTMLElement)) return;
  if (popupLink.hasAttribute(INITIALIZED_ATTRIBUTE)) return;

  const dialog = popupLink.querySelector('dialog');
  const closeButton = popupLink.querySelector('.popup-link__close');

  if (!(dialog instanceof HTMLDialogElement)) return;

  popupLink.setAttribute(INITIALIZED_ATTRIBUTE, 'true');

  popupLink.addEventListener(DialogOpenEvent.eventName, () => {
    trapFocus(dialog);

    if (closeButton instanceof HTMLElement) {
      closeButton.focus();
    }
  });

  popupLink.addEventListener(DialogCloseEvent.eventName, () => {
    removeTrapFocus();
  });
}

function initPopupLinks() {
  document.querySelectorAll(POPUP_LINK_SELECTOR).forEach(initPopupLinkFocusTrap);
}

initPopupLinks();

// Custom: Theme editor and section hydration can add popup-link blocks after initial load.
const observer = new MutationObserver(initPopupLinks);

observer.observe(document.documentElement, {
  childList: true,
  subtree: true,
});
